(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('KioskDashboardDeleteController',KioskDashboardDeleteController);

    KioskDashboardDeleteController.$inject = ['$uibModalInstance', 'entity', 'KiosksDashboards'];

    function KioskDashboardDeleteController($uibModalInstance, entity, KiosksDashboards) {
        var vm = this;
        vm.dashboard = entity.dashboard;
        vm.kioskId = entity.kioskId;

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.confirmDelete = function (id) {
            KiosksDashboards.deleteFromKiosk({id: id, kioskId: vm.kioskId, order: vm.dashboard.order},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
